<template>
    <div class="video-player">
        <youtube :video-id="source" ref="youtube" :player-vars="options" @playing="playing" @paused="paused" @ended="ended" fitParent resize></youtube>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['activity', 'closing'],

    data() {
        return {
            source: '',
            id_course: '',
            id_trail: '',
            interval: null,
            current_time: 0,
            total_time: '',
            options: {
                autoplay: 1,
                playsinline: 1
            },
            progress: null
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        player () { return this.$refs.youtube.player }
    },

    methods: {
        async playing() {
            this.total_time = await this.player.getDuration()

            this.interval = setInterval(() => {
                this.player.getCurrentTime().then((time) => {
                let progress = (time / this.total_time) * 100

                this.progress = progress < 100 ? progress : 100
                    this.updateTime(time + 1)
                })
            }, 60000)
        },

        updateTime(time) {
            this.current_time = time
            this.sendPosition()
        },

        paused() {
            this.sendPosition()
            clearInterval(this.interval)
        },

        ended() {
            this.current_time = this.total_time
            this.sendPosition()
            clearInterval(this.interval)
        },

        sendPosition() {
            if (this.current_time != 0) {
                let fd = new FormData()
                fd.append('current_time', this.current_time)
                fd.append('total_time', this.total_time)
                fd.append('id_group_training_module', this.activity.type_id)

                let url = ''
                if (this.id_trail == '') {
                    url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }
                else {
                    url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
                }

                this.$axios.post(url, fd, this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        youtubeParser(url){
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
            let match = url.match(regExp)
            this.source = (match && match[7].length == 11)? match[7] : false
        }
    },

    watch: {
        closing: function(val) {
            if (val == true) {
                this.sendPosition()
                clearInterval(this.interval)
                this.$emit('positionSent')
            }
        }
    },

    mounted() {
        this.player.seekTo(this.activity.current_time)
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
        this.youtubeParser(this.activity.resource)
    }
}
</script>

<style lang="stylus" scoped>

</style>
